<template>
  <div class="row">
    <div class="col-xl-3 col-lg-3 col-md-4">
      <div class="card">
        <div class="card-header bg-info text-light">
          My Account
        </div>
        <div class="card-body">
          <form @submit.prevent="submit" class="needs-validation">
            <div class="card border-dark mb-3">
              <div class="card-header">Basic Information</div>
              <div class="card-body">
                <fieldset class="form-group">
                  <label for="fname">First Name</label>
                  <input v-model="user.fname" type="text" :class="['form-control', { 'is-invalid':validationErrors.fname }]" id="fname" name="fname">
                  <div class="invalid-feedback" v-if="validationErrors.fname" v-text="validationErrors.fname"></div>
                </fieldset>
                <fieldset class="form-group">
                  <label for="lname">Last Name</label>
                  <input v-model="user.lname" type="text" :class="['form-control', { 'is-invalid':validationErrors.lname }]" id="lname" name="lname">
                  <div class="invalid-feedback" v-if="validationErrors.lname" v-text="validationErrors.lname"></div>
                </fieldset>
                <fieldset class="form-group">
                  <label for="email">Email</label>
                  <input v-model="user.email" type="text" :class="['form-control', { 'is-invalid':validationErrors.email }]" id="email" name="email">
                  <div class="invalid-feedback" v-if="validationErrors.email" v-text="validationErrors.email"></div>
                </fieldset>
              </div>
            </div>
            <div class="card border-dark mb-3">
              <div class="card-header">Change Password</div>
              <div class="card-body">
                <fieldset class="form-group">
                  <label for="password">New Password</label>
                  <input v-model="password" type="password" :class="['form-control', { 'is-invalid':validationErrors.password }]" id="password" name="password">
                  <div class="invalid-feedback" v-if="validationErrors.password" v-text="validationErrors.password"></div>
                </fieldset>
                <fieldset class="form-group">
                  <label for="password_confirm">New Password Confirm</label>
                  <input v-model="password_confirm" type="password" :class="['form-control', { 'is-invalid':validationErrors.password_confirm }]" id="password_confirm" name="password_confirm">
                  <div class="invalid-feedback" v-if="validationErrors.password_confirm" v-text="validationErrors.password_confirm"></div>
                </fieldset>
              </div>
            </div>
            <div v-if="formStatus.success === true" class="alert alert-success alert-dismissible" role="alert" style="margin-top:20px">
              <p>You account has been saved.</p>
              <button @click="clearFormStatus()" type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div v-else-if="formStatus.error === true" class="alert alert-danger alert-dismissible" role="alert" style="margin-top:20px">
              <h4 class="alert-heading" v-text="formStatus.statusHeading"></h4>
              <p v-text="formStatus.statusBody"></p>
              <button @click="clearFormStatus()" type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <button v-else type="submit" class="btn btn-primary">Save</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import User from '@/structs/User'

export default {
  name: 'UserAccountForm',
  computed: mapGetters('auth', ['currentUser']),
  data () {
    return {
      user: new User(),
      password: null,
      password_confirm: null,
      validationErrors: {
        fname: null,
        lname: null,
        email: null,
        password: null,
        password_confirm: null
      },
      formStatus: {
        success: null,
        error: null,
        statusHeading: null,
        statusBody: null
      }
    }
  },
  created () {
    const user = Object.assign(new User(), this.currentUser)
    this.setUser(user)
  },
  methods: {
    ...mapActions('user', ['updateUser']),
    submit () {
      if (this.validateForm()) {
        this.updateUser({ user: this.user, password: this.password })
          .then(updateduser => { console.log(updateduser); this.setUser(updateduser); this.markSuccess() })
          .catch(err => { this.markError(err) })
      }
    },
    setUser (u) {
      this.user = u
    },
    showCurrentUser () {
      console.log(this.currentUser)
    },
    clearFormStatus () {
      this.formStatus.success = null
      this.formStatus.error = null
      this.statusHeading = null
      this.statusBody = null
    },
    markSuccess () {
      this.clearFormStatus()

      this.formStatus.success = true
    },
    markError (message) {
      console.log(message)
      this.clearFormStatus()

      this.formStatus.statusHeading = 'Error'
      this.formStatus.statusBody = (message || 'Unable to create new user and/or organization.')
      this.formStatus.error = true
    },
    clearValidationErrors () {
      for (var k in this.validationErrors) {
        this.validationErrors[k] = null
      }
    },
    validateForm () {
      this.clearValidationErrors()

      if ((this.user.fname || '') === '') {
        this.validationErrors.fname = 'Empty or invalid first name'
        return false
      }

      if ((this.user.lname || '') === '') {
        this.validationErrors.lname = 'Empty or invalid last name'
        return false
      }

      if ((this.user.email || '') === '') {
        this.validationErrors.email = 'Empty or invalid email'
        return false
      }

      if ((this.password || '') !== '') {
        // only validate confirmation if they entered password
        if ((this.password_confirm || '') === '') {
          this.validationErrors.password_confirm = 'Empty or invalid password confirm'
          return false
        }

        if (this.password !== this.password_confirm) {
          this.validationErrors.password_confirm = 'Passwords must match'
          return false
        }
      }

      return true
    }
  }
}

</script>
